import { AfterViewInit, Component, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserService } from 'app/rest/user.service';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { RoutesService } from 'app/modules/task/administration/services/routes.service';
import { Rest_task } from 'app/modules/task/administration/services/rest_client_task';
import { Auxiliar } from 'app/model/Auxiliar';
import { RestExt } from 'app/services/rest-client-extension';
import { FilterAvailableDriversPipe } from 'app/modules/task/administration/helpers/pipes/FilterAvailableDriversPipe';

import User = Rest.User;
import Route = Rest_task.Route;
import RouteType = Rest_task.RouteType;
import { DelegationService } from 'app/modules/task/administration/services/delegation.service';
import { UserTaskService } from 'app/modules/task/administration/services/userTask.service';
import { TaskConstants } from 'app/modules/task/shared/task-constants';
import { Table } from 'primeng/table';
import { VehicleTaskService } from 'app/modules/task/administration/services/vehicleTask.service';
import { CustomerService } from 'app/modules/task/Logistics/services/customer.service';
import { Rest_logistics } from 'app/modules/task/Logistics/services/rest_client_logistics';
import Localization = Rest_logistics.Localization;
import { CercaliaAutocompleteComponent } from 'app/components/cercalia-autocomplete/cercalia-autocomplete.component';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { UtilsService } from 'app/services/utils/utils.service';
import { MultiSelect } from 'primeng/multiselect';
import { th } from 'date-fns/locale';
import { RestExtTask } from 'app/modules/task/rest-client-task-extension';
@Component({
    selector: 'app-delegation-form',
    templateUrl: './delegation-form.component.html',
    styleUrls: ['./delegation-form.component.css'],
    providers: [
        DelegationService,
        UserService,
        UserTaskService,
        RoutesService,
        VehicleTaskService,
        CustomerService,
        UtilsService,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DelegationFormComponent
	extends EntityFormComponent<Rest_task.Delegation>
	implements OnInit, AfterViewInit
{
	public configurationClient: Rest_logistics.clientconfiguration;
	confclientclass: Rest_logistics.configuration;
	noticeChannels: SelectItem[];
	channelsList: Rest.NoticeChannel[];
	title: string;
	usersBOTooltip: string;
	usersAppTooltip: string;
	routesTooltip: string;
	vehiclesTooltip: string;
	customersTooltip: string;
	//Language
	NingunUsuarioBO: string;
	NingunUsuarioApp: string;
	NingunaRuta: string;
	NingunVehiculo: string;
	rutastrad: string;
	usuariosbotrad: string;
	usuariosapptrad: string;
	vehiculsotrad: string;
	vehiculsotradPlural: string;
	customersLabel: string;
	noCustomersLabel: string;

	/*Permissions */
	disableSave: boolean;
	disabeChangeStatus: boolean;
	multipeDaysRouteDriverDefault: boolean = true;
	owner: User;
	permAlm: boolean = false;
	permClient: boolean = false;
	permRoutes: boolean = false;
	permVehicles: boolean = false;
	permUsersBO: boolean = false;
	permUsersApp: boolean = false;
	//test select bootsrap / prime ng

	availableUsersBO: User[];
	availableUsersApp: User[];

	selectedUsersApp: User[];
	selectedUsersBO: User[];
	selectedRoute: Rest_task.Route[];
	selectedVehicles: Rest.Vehicle[];
	selectedCustomers: Rest_logistics.Customer[];
	
	//availableDelegationUsersBO: Rest_task.DelegationUser[];
	//availableDelegationUsersApp: Rest_task.DelegationUser[];
	availableRoutes: Rest_task.Route[];
	availableVehicles: Rest.Vehicle[];
	availableCustomers: Rest_logistics.Customer[];


	delegationLocalization: Localization;
	@ViewChild(CercaliaAutocompleteComponent) cercaliaAuocomplete!: CercaliaAutocompleteComponent;
	user: Rest.User;
	@ViewChild(Table, { read: Table }) pTable: Table;
	@ViewChild('cercaliaAutocompleteAddress') cercaliaAutocompleteAddress!: CercaliaAutocompleteComponent;
	customersRequest: any;
	totalCustomers: number;
	customerFilter: string;
	loading = false;
	customersLoading = false;
	routesLoading = false;
	usersLoading = false;
	vehiclesLoading = false;
	@ViewChild('customersMultiselect') customersMultiselect: MultiSelect;
 
	typeahead = new Subject<string>();

	readonly pageSizePerformance = 20;

	private allData = Array.from({ length: 1000 }, (_, i) => ({ id: i, name: `Opción ${i}` }));
	private page = 0;
	private pageSize = 50;

	constructor(
		private routeService: DelegationService,
		notificationsService: NotificationsService,
		protected i18n: I18nService,
		private authenticationService: AuthenticationService,
		public translate: TranslateService,
		public userService: UserService,
		protected delegationService: DelegationService,
		private userTaskService: UserTaskService,
		private routesService: RoutesService,
		private vehiclesTaskService: VehicleTaskService,
		private customerService: CustomerService,
		protected loadingService: LoadingService,
		private utilsService: UtilsService
	) {
		super(delegationService, notificationsService, i18n, authenticationService);
	}
	ngAfterViewInit(): void {
		this.initLocalization();
	}

	ngOnInit() {
		super.ngOnInit();
		this.user = this.authenticationService.user;
		//
		// console.log('+++ ngOn entity', this.entity.disabled);
	}

	/**
	 * Loads and evaluates all the necessary data before showing the form.
	 *
	 * @memberof RouteFormComponent
	 */

	beforeShow() {
		this.setClientConfiguration();
		this.selectedUsersBO = null;
		this.selectedUsersApp = null;
		this.selectedRoute= this.entity.routedata?.filter((route) => !route.deleted);
		this.selectedVehicles = this.entity.vehicledata?.filter((vehicle) => vehicle.enabled);
		this.selectedCustomers = this.entity.customers?.filter((customer) => !customer.deleted);	

		

		this.setTranslations();
		this.customerFilter = '';
		this.loadFormData();
		/*
    this.getUsers(this.user.id, this.entity?.id),
    this.getRoutes()
    this.getVehicles()
    this.getCustomers();
    */
		this.setFormActions();
		this.initLocalization();
		
	}

	loadFormData() {
		let that = this;
		Promise.all([
			this.getUsers(this.user.id, this.entity?.id),
			this.getRoutes(),
			this.getVehicles(),
			this.getCustomers(),
		]).catch((error) => {
			console.log(error);
		});
	}

	getUsers(userId, delegationId): Promise<void> {
		let paginationRequest = RestExt.firstPageRequest();
		const that = this;
		paginationRequest.filters = { enabled: ['true'] };
		this.usersLoading = true;
		return this.userService
			.userAllDataTask(userId)
			.then(
				function (response) {
					//Usuaris

					that.availableUsersBO = response.children.filter(
						(user) => user.usertype.some((type) => type.projectstype.id == 4) && user.enabled == true
					);
					that.availableUsersApp = response.children.filter(
						(user) =>
							user.usertype.some((type) => type.projectstype.id == 2) &&
							user.enabled == true &&
							(user.delegUserData == null ||
								user.delegUserData.length === 0 ||
								user.delegUserData.some((y) => y.delegation.id === delegationId && delegationId > 0))
					);

					that.selectedUsersBO = that.userTaskService.convertDelegationUsers_To_Users(
						that.entity.delegUserData.filter((delegationUser) => delegationUser.user.enabled == true &&
							delegationUser.user.usertype.some((type) => type.projectstype.id == 4)
						)
					);
					that.selectedUsersApp = that.userTaskService.convertDelegationUsers_To_Users(
						that.entity.delegUserData.filter((delegationUser) => delegationUser.user.enabled == true &&
							delegationUser.user.usertype.some((type) => type.projectstype.id == 2)
						)
					);

					that.availableUsersBO.sort((a, b) => a.name.localeCompare(b.name));
					that.availableUsersApp.sort((a, b) => a.name.localeCompare(b.name));

					that.setAllMultiselectTooltips();
					//rutes
					//that.availableRoutes = response.route.filter(x => x.delegation == null || x.delegation.id == delegationId)

					//Vehicles
					// that.availableVehicles = response.vehicles.filter(x => x.delegation == null);
				},

				function (error) {}
			)
			.catch(function (reason) {
				console.log(reason);
			})
			.finally(() => {
				this.usersLoading = false;
			});
	}

	async saveDelegationForm() {
		if (this.validateDelegationForm()) {
			this.entity.delegUserData = this.getSelectedDelegationUser();
			this.entity.routedata = this.selectedRoute;
			this.entity.vehicledata = this.selectedVehicles;
			this.entity.customers = this.selectedCustomers;
			this.loading = true;
			await this.saveAsync();
			this.loading = false;
		}
	}

	validateDelegationForm() {
		if (this.entity.codename == null || this.entity.codename == '') {
			this.notificationsService.add(
				Severity.warn,
				'',
				this.translate.instant('logistics.routes.errors.erremptyfields')
			);
			return false;
		}

		if (this.cercaliaAutocompleteAddress && this.cercaliaAutocompleteAddress.addressEditing) {
			this.notificationsService.add(
				Severity.warn,
				'',
				this.translate.instant('administration.customers.addressEditingWarning')
			);
			return false;
		}

		return true;
	}

	getSelectedDelegationUser(): Rest_task.DelegationUser[] {
		let selectedDelegationUserBO = this.userTaskService.convertUsers_To_DelegationUsers(this.selectedUsersBO);
		let selectedDelegationUserApp = this.userTaskService.convertUsers_To_DelegationUsers(this.selectedUsersApp);
		return selectedDelegationUserBO?.concat(selectedDelegationUserApp);
	}

	//multiselects tooltips (de moment no estan posats)
	setUsersBOTooltip() {
		this.usersBOTooltip = '';
		this.usersBOTooltip = this.selectedUsersBO
			.map((selectedItem) => selectedItem.name + ' ' + selectedItem.surname1)
			.join(', ');
	}
	setUsersAppTooltip() {
		this.usersAppTooltip = '';
		this.usersAppTooltip = this.selectedUsersApp
			.map((selectedItem) => selectedItem.name + ' ' + selectedItem.surname1)
			.join(', ');
	}

	setRoutesTooltip() {
		this.routesTooltip = '';
		//this.routesTooltip = this.entity.routedata.map((selectedItem) => selectedItem.name).join(', ');
		this.routesTooltip = this.selectedRoute?.map((selectedItem) => selectedItem.name).join(', ');
	}
	setVehiclesTooltip() {
		this.vehiclesTooltip = '';
		//this.vehiclesTooltip = this.entity.vehicledata.map((selectedItem) => selectedItem.name).join(', ');
			this.vehiclesTooltip = this.selectedVehicles?.map((selectedItem) => selectedItem.name).join(', ');
	}
	setCustomersTooltip() {
		this.customersTooltip = '';
		//this.customersTooltip = this.entity.customers.map((selectedItem) => selectedItem.name1).join(', ');
		this.customersTooltip = this.selectedCustomers?.map((selectedItem) => selectedItem.name1).join(', ');
	}
	setClientConfiguration() {
		//Nueva conifguracion de cliente multipeDaysRouteDriverDefault
		this.multipeDaysRouteDriverDefault = false;
		//others configurations client
		this.permAlm = false;
		this.permClient = false;
		this.permRoutes= false;
		this.permVehicles=false;
		this.permUsersBO = RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_USERSBO_VIEW, this.user);
		this.permUsersApp = RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_USERSAPP_VIEW, this.user);
		this.configurationClient = this.user.client.clientconfiguration;
		if (this.configurationClient !== null && this.configurationClient.configuration !== '') {
			this.confclientclass = JSON.parse(this.configurationClient.configuration);
			if (this.confclientclass.admin !== null) {
				if (this.confclientclass.admin.delegations.store == true) {
					this.permAlm = true;
				}
				if (this.confclientclass.admin.delegations.clients == true) {
					this.permClient = true;
				}
				if (this.confclientclass.admin.delegations.routes == true) {
					this.permRoutes = true;
				}
				if (this.confclientclass.admin.delegations.vehicles == true) {
					this.permVehicles = true;
				}
			}
		}
	}

	setAllMultiselectTooltips() {
		this.setUsersBOTooltip();
		this.setUsersAppTooltip();
		this.setRoutesTooltip();
		this.setVehiclesTooltip();
		this.setCustomersTooltip();
	}

	public getRoutes(): Promise<void> {
		let routesRequest = {
			sortBy: null,
			sortAsc: true,
			pageSize: 1000000,
			filters: {
				unassigned: ['true'],
				//"deleted": ["false"],
				delegationId: [this.getDelegationIdFilter()],
				deleted: ['false'],
			},

			loadPermissions: false,
		} as unknown as Rest.ListPaginationRequest;

		const that = this;
		this.routesLoading = true;
		return this.routesService
			.getPage(routesRequest)
			.then(
				function (response) {
					that.availableRoutes = response.entities;

					that.availableRoutes.sort((a, b) => a.name.localeCompare(b.name));
					that.setRoutesTooltip();
					/*  if(that.entity.routedata){
                   that.availableRoutes = that.availableRoutes.concat(that.entity.routedata);
              } */
					// that.usersLoaded = true;
				},
				/* failure */
				function (error) {
					console.log('The request failed: ' + error);
				}
			)
			.catch(function (reason) {
				console.log('Catched: ' + reason);
			})
			.finally(() => {
				this.routesLoading = false;
			});
	}

	public getVehicles(): Promise<void> {
		let vehiclesRequest = {
			sortBy: null,
			sortAsc: true,
			pageSize: 1000000,
			filters: {
				unassigned: ['true'],
				//"deleted": ["false"],
				delegationId: [this.getDelegationIdFilter()],
				enabled: ['true'],
			},
			loadPermissions: false,
		} as unknown as Rest.ListPaginationRequest;

		const that = this;
		this.vehiclesLoading = true;
		return this.vehiclesTaskService
			.getPage(vehiclesRequest)
			.then(
				function (response) {
					that.availableVehicles = response.entities;
					that.availableVehicles.sort((a, b) => a.name.localeCompare(b.name));
					that.setVehiclesTooltip();
					// that.usersLoaded = true;
				},
				/* failure */
				function (error) {
					console.log('The request failed: ' + error);
				}
			)
			.catch(function (reason) {
				console.log('Catched: ' + reason);
			})
			.finally(() => {
				this.vehiclesLoading = false;
			});
	}

	
	public getCustomers(): Promise<void> {
		this.customersRequest = {
			sortBy: 'name1',
			sortAsc: true,
			pageSize: this.pageSizePerformance,
			//			 pageSize: 1000000,

			filters: {
				deleted: ['false'],
				...(this.customerFilter?.trim() ? { name1: [this.customerFilter.trim()] } : {}),
			},
			loadPermissions: false,
			loadRelations: false,
		} as unknown as Rest.ListPaginationRequest;

		const that = this;
		this.customersLoading = true;
		return this.customerService
			.getPage(this.customersRequest)
			.then(
				function (response) {
					that.availableCustomers = [...response.entities];
					that.availableCustomers = that.utilsService. handleMultiSelectFilterResponse(
						that.availableCustomers,
						that.entity.customers,
						that.customerFilter,
						"name1", 
						that.pageSizePerformance,
					);
					//that.setCustomersTooltip();
					that.availableCustomers = that.markDuplicates(that.availableCustomers);

					that.customersMultiselect._filteredOptions = that.availableCustomers;
					that.totalCustomers = response.filteredEntities;
				},
				/* failure */
				function (error) {
					console.log('The request failed: ' + error);
				}
			)
			.catch(function (reason) {
				console.log('Catched: ' + reason);
			})
			.finally(() => {
				this.customersLoading = false;
			});
	}


/*
	handleMultiSelectFilterResponse(availableItems: any[], selectedItems: any[], filter: string) {
		//SERVEIX PER MILLORAR RENDIMENT EN MULTISELECTS AMB MOLTS ITEMS
		var selectedItemsFiltered = [...selectedItems];
		try {
			//availableItems venen filtrats de servidor (multiselect options)
			//selectedItems no estan filtrats (multiselect ngModel)
			if (filter?.trim()) {
				//filtra selectedItems amb el text introduit per ususari
				selectedItemsFiltered = selectedItemsFiltered?.filter((item) =>
					item.name1?.toLowerCase().includes(filter?.trim()?.toLowerCase())
				);
			}

			//suma arrays selectedItems + availableItems eliminant duplicats i retorna un maxim de items
			const availableItemsResult = [
				...selectedItemsFiltered,
				...availableItems.filter((item) => !selectedItemsFiltered?.some((sel) => sel.id === item.id)),
			];
			var resultSize = Math.min(this.pageSizePerformance, availableItemsResult.length);
			return availableItemsResult.slice(0, resultSize);
 
		} catch (e) {
			console.log(e);
		}
	}
	*/
private markDuplicates(customers: any[]): any[] {
	const nameCounts = customers.reduce((acc, curr) => {
		acc[curr.name1] = (acc[curr.name1] || 0) + 1;
		return acc;
	}, {} as Record<string, number>);

	return customers.map(c => ({
		...c,
		isDuplicate: nameCounts[c.name1] > 1
	}));
	}

	getDelegationIdFilter() {
		return this.isNew ? -1 : this.entity.id;
	}

	onNewLocationSelected(newLocation: Localization) {
		//this.delegationLocalization = this.mapCercaliaToLocalization(newLocation);
		this.delegationLocalization = newLocation;
		this.entity.localizations = [];
		if (this.delegationLocalization) {
			this.entity.localizations.push(this.delegationLocalization);
		}
	}

	setTranslations() {
		this.NingunUsuarioBO = this.translate.instant('tableManagement.delegations.NoBOUser');
		this.NingunUsuarioApp = this.translate.instant('tableManagement.delegations.NoAppUser');
		this.NingunaRuta = this.translate.instant('tableManagement.delegations.NoRoute');
		this.NingunVehiculo = this.translate.instant('tableManagement.delegations.NoVehicle');
		this.rutastrad = this.translate.instant('administration.routes.routes');
		this.usuariosbotrad = this.translate.instant('administration.usersbo.usersbo2');
		this.usuariosapptrad = this.translate.instant('administration.usersapp.usersapp');
		if (this.confclientclass?.admin?.vehicle != null) {
			const label = this.confclientclass.admin.vehicle.label;
			this.translate.get('navbar.' + label).subscribe((value) => this.vehiculsotrad = value);
			this.translate.get('navbar.' + label + 's').subscribe((value) => this.vehiculsotradPlural = value);
		} else {
			this.translate.get('navbar.vehicles').subscribe((value) => {
				this.vehiculsotrad = value;
				this.vehiculsotradPlural = value;
			});
		}
		this.customersLabel = this.translate.instant('administration.customers.customers');
		this.noCustomersLabel = this.translate.instant('administration.customers.notcustomers');
	}

	/*
	mapCercaliaToLocalization(location: any): Localization {
		return {
			id: 0,
			name: location.address1,
			address1: location.address1,
			address2: location.address2,
			city: location.city,
			postalCode: location.postCode,
			municipality: location.city,
			province: location.state,
			latitude: location.latitude,
			longitude: location.longitude,
		};
	}

	mapLocalizationToCercalia(localization: Localization): any {
		return {
			id: localization.id,
			name1: localization.name,
			address1: localization.address1,
			address2: localization.address2,
			city: localization.city,
			postCode: localization.postalCode,
			state: localization.province,
			latitude: localization.latitude,
			longitude: localization.longitude,
		};
	}
*/
	initLocalization() {
		this.delegationLocalization = null;
		if (this.entity.localizations != null && this.entity.localizations.length > 0) {
			this.delegationLocalization = this.entity.localizations[0];
		}

		//this.cercaliaAuocomplete.initCercaliaSubscirption();
	}

	setFormActions() {
		/*Permissions */
		if (this.isNew) {
			this.disableSave = false;
			this.title = this.translate.instant('tableManagement.delegations.createDelegation');
		} else {
			this.title = this.translate.instant('tableManagement.delegations.editDelegation');
			if (this.entity['_$update'] === true) {
				this.disableSave = false;
			} else {
				this.disableSave = true;
			}
			if (this.entity['_$changeStatus'] === true) {
				this.disabeChangeStatus = false;
			} else {
				this.disabeChangeStatus = true;
			}
		}
	}

	onFilterCustomer(event) {
		this.customerFilter = event.filter ?? '';
		this.getCustomers();
	}

	//TEST
	cities: any;
	selectedCities: any;

	setMultiSelectTest() {
		this.cities = [
			{ name: 'New York', code: 'NY' },
			{ name: 'Rome', code: 'RM' },
			{ name: 'London', code: 'LDN' },
			{ name: 'Istanbul', code: 'IST' },
			{ name: 'Paris', code: 'PRS' },
			...Array.from({ length: 4000 }, (_, i) => ({
				name: `City${i + 1}`,
				code: `C${(i + 1).toString().padStart(4, '0')}`,
			})),
		];
		this.selectedCities = this.cities;
	}
}
